export const ANALYTICS_KEY_CONSUMPTION = 'stroomverbruik jaar';
export const ANALYTICS_KEY_ASBESTOS = 'asbest aanwezigheid';
export const ANALYTICS_KEY_ROOF_TYPE = 'type dak';
export const ANALYTICS_KEY_RENEWED_ROOF = 'dak vervangen binnen termijn';
export const ANALYTICS_KEY_EMAIL = 'e mailadres';
export const ANALYTICS_KEY_HOMEBATTERY_INTEREST =
  'Ik heb mogelijk ook interesse in een thuisbatterij, met combikorting';
